import { Component } from '@angular/core';
import {
  Maps,
  MapsTooltip,
  ISelectionEventArgs,
  Selection,
  Highlight,
  MapsModule,
  MapsTooltipService,
  DataLabelService,
} from '@syncfusion/ej2-angular-maps';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { DataService } from '../../../../../../services/dashboard/data.service';
import { italyMap } from '../../../../../../shared/italy-regions';
import { NtPotentialRegionInterface } from '../../../../../../shared/interfaces/nt-potential-region.interface';
import { NtForecastCompleteAccess } from '../../../../../../shared/interfaces/nt-forecast-complete-access-map-interface';
import { CommonModule } from '@angular/common';

Maps.Inject(MapsTooltip, Selection, Highlight);

@Component({
  selector: 'app-map-forecast-complete-access',
  imports: [MapsModule, CommonModule],
  providers: [MapsTooltipService, DataLabelService],
  templateUrl: './map-forecast-complete-access.component.html',
  styleUrl: './map-forecast-complete-access.component.css',
})
export class MapForecastCompleteAccessComponent {
  public mapWidth: string = '98%';
  public mapHeight: string = '98%';
  public layers?: object[];
  public medicineId = 0;
  public companyId = 0;
  public countryId = 1;

  regionId = 0;
  regionName = '';

  isActiveModalHospital = false;

  dataMockup: NtForecastCompleteAccess[] = [
    { regionId: 14, regionName: 'Abruzzo', months: 5 },
    { regionId: 18, regionName: 'Basilicata', months: 4 },
    { regionId: 19, regionName: 'Calabria', months: 7 },
    { regionId: 16, regionName: 'Campania', months: 3 },
    { regionId: 9, regionName: 'Emilia-Romagna', months: 9 },
    { regionId: 7, regionName: 'Friuli Venezia Giulia', months: 2 },
    { regionId: 13, regionName: 'Lazio', months: 4 },
    { regionId: 8, regionName: 'Liguria', months: 2 },
    { regionId: 3, regionName: 'Lombardia', months: 10 },
    { regionId: 12, regionName: 'Marche', months: 3 },
    { regionId: 15, regionName: 'Molise', months: 2 },
    { regionId: 2, regionName: 'Piemonte', months: 9 },
    { regionId: 5, regionName: 'Prov. Aut. di Bolzano', months: 1 },
    { regionId: 4, regionName: 'Prov. Aut. di Trento', months: 1 },
    { regionId: 17, regionName: 'Puglia', months: 12 },
    { regionId: 21, regionName: 'Sardegna', months: 2 },
    { regionId: 20, regionName: 'Sicilia', months: 4 },
    { regionId: 10, regionName: 'Toscana', months: 8 },
    { regionId: 11, regionName: 'Umbria', months: 3 },
    { regionId: 1, regionName: "Valle D'Aosta", months: 11 },
    { regionId: 6, regionName: 'Veneto', months: 3 },
  ];

  constructor(private dataService: DataService) {}

  ngOnInit(): void {
    this.layers = [
      {
        shapeData: italyMap,
      },
    ];

    this.medicineId = sessionStorage.getItem('medicineId')
      ? Number(sessionStorage.getItem('medicineId'))
      : 0;
    this.countryId = sessionStorage.getItem('countryId')
      ? Number(sessionStorage.getItem('countryId'))
      : 1;
    this.companyId = sessionStorage.getItem('companyId')
      ? Number(sessionStorage.getItem('companyId'))
      : 0;
    this.loadData();
    /*
    this.dataService.medicineUpdated$.subscribe((medicineId: number) => {
      if (medicineId !== 0) {
        this.medicineId = medicineId;
        this.loadData();
      }
    });
*/
  }

  loadData() {
    //const data = this.dataMockup;

    this.dataService
      .getForecastCompleteAccess(
        this.companyId,
        this.medicineId,
        this.countryId,
      )
      .subscribe({
        next: (data) => {
          if (data && data.length > 0) {
            // console.log('data MAPPA MOCK', data);

            const regioniData = data.map((item) => {
              return {
                ...item,
                tooltipText: `${
                  item.regionName === 'Prov. Aut. di Bolzano'
                    ? 'PA di Bolzano'
                    : item.regionName === 'Prov. Aut. di Trento'
                      ? 'PA di Trento'
                      : item.regionName
                }: <br>${item.months} ${item.months === 1 ? 'mese' : 'mesi'}`,
              };
            });

            this.layers = [
              {
                shapeData: italyMap,
                shapePropertyPath: 'id',
                shapeDataPath: 'regionId',
                dataSource: regioniData,
                tooltipSettings: {
                  visible: true,
                  valuePath: 'tooltipText',
                  textStyle: {
                    size: '10px',
                  },
                },
                highlightSettings: {
                  enable: false,
                },
                selectionSettings: {
                  enable: false,
                  fill: '#FFFFFF',
                  border: {
                    color: '#162456',
                    width: 1,
                  },
                  opacity: 1,
                },
                shapeSettings: {
                  fill: '#FFFFFF',
                  colorValuePath: '#DDE1E5',
                  border: {
                    color: '#162456',
                    width: 0.7,
                  },
                },
              },
            ];
          }
        },
      });
  }
}
